import React, { Component } from 'react'
import Client from '../Client'
import BlackLoading from '../images/black-loader.gif';
import {Carousel} from 'react-bootstrap';

class PotteryGardenFlashImages extends Component {
  constructor(props) {
    super(props)
    this.state = {
         potterygardenflashimg:[]
    }
}

componentDidMount(){
    Client.getEntries({
        'content_type': 'potterygardenFlashImages',

    }).then((entries)=>{
        this.setState({potterygardenflashimg: entries.items})
    });
}


render() {
  return (
    <>
        {this.state.potterygardenflashimg.length === 0 ?
              <div align="center"><img src={BlackLoading} alt="Loading..." /></div> :
        <Carousel fade={false}>
          
          {this.state.potterygardenflashimg.map((item, index) => {
            return(
            <Carousel.Item key={index}>
            <img
              className="d-block w-100"
              src={item.fields.potterygardenFlashImagesImg.fields.file.url}
              alt="sam bridge pottery garden supplies slide"
            />
            <Carousel.Caption>
                <span className="slidefont">{item.fields.potterygardenFlashImagesTitle}</span>
            </Carousel.Caption>
            </Carousel.Item>
                  )
                  })}
        </Carousel>
        }

    </>
    )
  }
}

export default PotteryGardenFlashImages;


